/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_LabelInputs */

const en_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Event Selection`)
};

const fr_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la sélection d'événements`)
};

const de_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export-Ereignisauswahl`)
};

const it_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta selezione evento`)
};

const ru_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор экспортируемого события`)
};

const es_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de eventos de exportación`)
};

const zh_cn2_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出事件选择`)
};

const ja_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント選択のエクスポート`)
};

const hi_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात इवेंट चयन`)
};

const pt_pt2_audio_description_export_selection_label = /** @type {(inputs: Audio_Description_Export_Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de Eventos de Exportação`)
};

/**
* | output |
* | --- |
* | "Export Event Selection" |
*
* @param {Audio_Description_Export_Selection_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_label = /** @type {((inputs?: Audio_Description_Export_Selection_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selection_label(inputs)
	if (locale === "de") return de_audio_description_export_selection_label(inputs)
	if (locale === "it") return it_audio_description_export_selection_label(inputs)
	if (locale === "ru") return ru_audio_description_export_selection_label(inputs)
	if (locale === "es") return es_audio_description_export_selection_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selection_label(inputs)
	if (locale === "ja") return ja_audio_description_export_selection_label(inputs)
	if (locale === "hi") return hi_audio_description_export_selection_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selection_label(inputs)
	return en_audio_description_export_selection_label(inputs)
});